import { z } from "zod";

const EXAMPLE_FOLDER =
  "https://paxusercontent.co/profiles/0199f0be-4d1a-7b55-8c71-59a0d2e6c884/avatar/k3v9x2mq7tfa";

export const ImageSource = z
  .strictObject({
    url: z.url().meta({
      description: "Where the file is served.",
      example: `${EXAMPLE_FOLDER}/128.avif`,
    }),
    width: z.int().positive().meta({ description: "The file's width in pixels.", example: 128 }),
    height: z.int().positive().meta({ description: "The file's height in pixels.", example: 128 }),
  })
  .meta({ id: "ImageSource", description: "One size of an image." });
export type ImageSource = z.infer<typeof ImageSource>;

export const ImageSet = z
  .strictObject({
    sources: z.array(ImageSource).min(1).meta({
      description:
        "Every size of the image, smallest first. All of them are in one format that every Pax client can show.",
    }),
  })
  .meta({
    id: "ImageSet",
    description:
      "One image in several sizes. Load the smallest source that covers the space the image is drawn in, at the screen's pixel density.",
    example: {
      sources: [64, 128, 256, 512].map(size => ({
        url: `${EXAMPLE_FOLDER}/${size}.avif`,
        width: size,
        height: size,
      })),
    },
  });
export type ImageSet = z.infer<typeof ImageSet>;
